import {
  FETCHING_INVITATION,
  FETCHING_INVITATION_SUCCEEDED,
  FETCHING_INVITATION_FAILED,
  FETCHING_INVITATIONS,
  FETCHING_INVITATIONS_SUCCEEDED,
  FETCHING_INVITATIONS_FAILED,
  FETCHING_INVITATIONS_COUNT,
  FETCHING_INVITATIONS_COUNT_SUCCEEDED,
  FETCHING_INVITATIONS_COUNT_FAILED,
  RESENDING_INVITATION_REQUEST,
  RESENDING_INVITATION_SUCCEEDED,
  RESENDING_INVITATION_FAILED,
  DELETING_INVITATION_REQUEST,
  DELETING_INVITATION_SUCCEEDED,
  DELETING_INVITATION_FAILED,
  INVITING_USER_REQUEST,
  INVITING_USER_REQUEST_SUCCEEDED,
  INVITING_USER_REQUEST_FAILED
} from "constants/actionTypes";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const INVITATIONS_BASE_URL = `${API_URL}/api/1.0/invitations`;

/** fetch invitation */
export const fetchInvitation = createAction(FETCHING_INVITATION);
const fetchingInvitationSucceeded = createAction(FETCHING_INVITATION_SUCCEEDED);
const fetchingInvitationFailed = createAction(FETCHING_INVITATION_FAILED);

function* fetchInvitationSaga(id) {
  let url = buildUrl(INVITATIONS_BASE_URL, `${id}`);
  const fetchInvitationAPI = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchInvitationAPI);
    yield put(fetchingInvitationSucceeded(response));
  } catch (error) {
    yield put(fetchingInvitationFailed(error));
  }
}

/** fetch invitations */
export const fetchInvitations = createAction(FETCHING_INVITATIONS);
const fetchingInvitationsSucceeded = createAction(
  FETCHING_INVITATIONS_SUCCEEDED
);
const fetchingInvitationsFailed = createAction(FETCHING_INVITATIONS_FAILED);

function* fetchInvitationsSaga(action) {
  let { page, limit, filters } = action.payload;

  let url = buildUrl(INVITATIONS_BASE_URL, { path: "/search" });
  const fetchInvitationsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: { page, limit },
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchInvitationsAPI);
    yield put(fetchingInvitationsSucceeded(response));
  } catch (error) {
    yield put(fetchingInvitationsFailed(error));
  }
}

/** fetch invitations count */
export const fetchInvitationsCount = createAction(FETCHING_INVITATIONS_COUNT);
const fetchingInvitationsCountSucceeded = createAction(
  FETCHING_INVITATIONS_COUNT_SUCCEEDED
);
const fetchingInvitationsCountFailed = createAction(
  FETCHING_INVITATIONS_COUNT_FAILED
);

function* fetchInvitationsCountSaga(action) {
  let { account, type } = action.payload;

  let url = buildUrl(INVITATIONS_BASE_URL, { path: "/count" });
  const fetchInvitationsCountAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { account, type },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchInvitationsCountAPI);
    yield put(fetchingInvitationsCountSucceeded(response));
  } catch (error) {
    yield put(fetchingInvitationsCountFailed(error));
  }
}

/** resend invitation */
export const resendInvitation = createAction(RESENDING_INVITATION_REQUEST);
const resendingInvitationSucceeded = createAction(
  RESENDING_INVITATION_SUCCEEDED
);
const resendingInvitationFailed = createAction(RESENDING_INVITATION_FAILED);

function* resendInvitationSaga(action) {
  let { id } = action.payload;

  let url = buildUrl(INVITATIONS_BASE_URL, { path: `${id}/resend` });
  const resendInvitaionAPI = () => {
    return axios({
      method: "POST",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(resendInvitaionAPI);
    yield put(resendingInvitationSucceeded(response));
  } catch (error) {
    yield put(resendingInvitationFailed(error));
  }
}

/** delete invitation */
export const deleteInvitation = createAction(DELETING_INVITATION_REQUEST);
const deletingInvitationSucceeded = createAction(DELETING_INVITATION_SUCCEEDED);
const deletingInvitationFailed = createAction(DELETING_INVITATION_FAILED);

function* deleteInvitationSaga(action) {
  let { id } = action.payload;

  let url = buildUrl(INVITATIONS_BASE_URL, { path: `${id}` });
  const deleteInvitationAPI = () => {
    return axios({
      method: "DELETE",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteInvitationAPI);
    yield put(deletingInvitationSucceeded(response));
  } catch (error) {
    yield put(deletingInvitationFailed(error));
  }
}

/** invite Users */
export const invitingUser = createAction(INVITING_USER_REQUEST);
const createInvitationSucceeded = createAction(INVITING_USER_REQUEST_SUCCEEDED);
const createInvitationFailed = createAction(INVITING_USER_REQUEST_FAILED);
let url = buildUrl(INVITATIONS_BASE_URL);
function* createInvitationSaga(action) {
  let { accountId,invite} = action.payload;
  const createInvitaionAPI = () => {
    return axios({
      method: "POST",
      url: url, 
      data:invite,
      params: { accountId },
      
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createInvitaionAPI);
    yield put(createInvitationSucceeded(response));
  } catch (error) {
    yield put(createInvitationFailed(error));
  }
}


export default function* invitationsSaga() {
  yield takeLatest(FETCHING_INVITATION, fetchInvitationSaga);
  yield takeLatest(FETCHING_INVITATIONS, fetchInvitationsSaga);
  yield takeLatest(FETCHING_INVITATIONS_COUNT, fetchInvitationsCountSaga);
  yield takeLatest(RESENDING_INVITATION_REQUEST, resendInvitationSaga);
  yield takeLatest(DELETING_INVITATION_REQUEST, deleteInvitationSaga);
  yield takeLatest(INVITING_USER_REQUEST, createInvitationSaga);
  
}
